import { CheckCircleIcon } from "@chakra-ui/icons";
import { Box, Button, Container, Heading, Text } from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router-dom";

const Success = () => {
  const navigate = useNavigate();
  return (
    <Container maxW="md" py={150} textAlign="center">
      <Box p={5} borderWidth="1px" borderRadius="md" boxShadow="md">
        <CheckCircleIcon boxSize={12} color="green.500" />
        <Heading py={5} as="h2" size="xl" mt={6} mb={4}>
          Payment Complete
        </Heading>
        <Text mb={4} color="gray.600">
          Thank you for your payment! Your transaction has been completed
          successfully.
        </Text>
        <Text py={10}>Thank you for choosing our service!</Text>
        <Button mt={6} colorScheme="green" onClick={() => navigate("/")}>
          Back Home
        </Button>
      </Box>
    </Container>
  );
};

export default Success;
